<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Invoice #{{ invoice_id }}</p>
      </header>
      <section class="modal-card-body">
        <div class="content" v-if="invoice">
          <h1>{{ getName() }}</h1>
          <h2 style="margin-top: 0px;"><b>Invoice Deadline:</b> {{ invoice.deadline }}</h2>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th>Booking-Service</th>
                <th>Hotel</th>
                <th>Check-in</th>
                <th v-if="edit">PO</th>
                <th>Main PAX</th>
                <th>Value</th>
                <template v-if="edit">
                  <th></th>
                </template>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="service in invoice.invoice_services" v-if="(service.service.status == 'Confirmed') || (service.service.status === 'PendingCancellation') || ((service.service.status === 'Cancelled') && ((new Date(service.service.service_date)).getTime() <= (new Date(service.service.cancellation_date).getTime()))) || parseInt(service.service.dispute) == 1 || parseInt(service.protected) == 1">
                <td>{{ parseInt(service.service.integration) === 1 ? service.service.booking_id + '/' + service.service.service_id : parseInt(service.service.integration) === 2 ? service.service.api_booking_id + '/' + service.service.api_service_id : 'Manual/' + service.service.id }}</td>
                <td>{{ service.service.room.hotel.name }}</td>
                <td>{{ parseDate(service.service.service_date) }}</td>
                <td v-if="edit"><a v-if="service.service.payment_order" :style="{'color': service.service.payment_order && service.service.payment_order.payment.payment === 1 ? 'green': 'red'}" @click="openPayment(service.service.payment_order.payment.id)">{{ service.service.payment_order ? service.service.payment_order.payment.id : '' }}</a></td>
                <td>{{ service.service.main_pax }}</td>
                <template v-if="invoice.base != null && parseInt(invoice.base.is_markup) == 1">
                    <td style="width: 150px;">+{{ parseFloat((service.service.room.provider_price) / ((100 - invoice.base.markup) / 100) + parseFloat(invoice.base.bf)).toFixed(2) }}</td>
                </template>
                <template v-else>
                  <td style="width: 150px;">+{{ service.service.price }}</td>
                </template>
                <td style="text-align: center">
                  <template v-if="showExclude() && edit">
                    <tooltip label="Exclude" type="default" placement="left">
                      <a class="button button-table is-small" @click="exclude(service.service.id, service.service.service_id)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </tooltip>
                  </template>
                  <tooltip label="View" type="default" placement="left">
                    <a class="button button-table is-small" @click="url(service.service.id)">
                      <i class="fa fa-eye"></i>
                    </a>
                  </tooltip>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr v-if="edit">
                <td colspan="6" style="border:none; text-align: right; width: 900px;"></td>
                <td colspan="1">
                  <template v-if="showExclude()">
                    <tooltip label="Exclude All" type="default" placement="left">
                      <a class="button button-table is-small" @click="excludeAll()">
                        <i class="fa fa-trash"></i>
                      </a>
                    </tooltip>
                  </template>
                </td>
              </tr>
              <tr>
                <td colspan="5" style="border:none; text-align: right; width: 900px;"><b>SUB TOTAL</b></td>
                <td colspan="2"><b>{{ calcServices() }} {{ invoice.currency }}</b></td>
              </tr>
            </tfoot>
          </table>
          <template v-if="showDebitCredit()">
          <h2 style="margin-top: 0px;"><b>Credits/Debits</b></h2>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th>Booking-Service</th>
                <th>Description</th>
                <th>Hotel</th>
                <th>Check-in</th>
                <th>Main PAX</th>
                <th>Value</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="invoice_financial in invoice.invoice_financials">
                <tr>
                  <td>{{ parseInt(invoice_financial.financial.service.integration) === 1 ? invoice_financial.financial.service.booking_id + '/' + invoice_financial.financial.service.service_id : invoice_financial.financial.service.api_booking_id + '/' + invoice_financial.financial.service.api_service_id }}</td>
                  <td>{{ invoice_financial.financial.observation }}</td>
                  <td>{{ invoice_financial.financial.service.room.hotel.name }}</td>
                  <td>{{ parseDate(invoice_financial.financial.service.service_date) }}</td>
                  <td>{{ invoice_financial.financial.service.main_pax }}</td>
                  <td>{{ parseInt(invoice_financial.financial.type) == 2 ? '+' : '-'}}{{ invoice_financial.financial.gross_price }}</td>
                  <td style="text-align: center;" v-if="edit">
                    <template v-if="showExclude()">
                        <tooltip label="Exclude" type="default" placement="left">
                          <a class="button button-table is-small" @click="excludeFinancial(invoice_financial.financial.id)">
                            <i class="fa fa-trash"></i>
                          </a>
                        </tooltip>
                    </template>
                    <tooltip label="View" type="default" placement="left">
                      <a class="button button-table is-small" @click="url(invoice_financial.financial.service.id)">
                        <i class="fa fa-eye"></i>
                      </a>
                    </tooltip>
                  </td>
                </tr>
              </template>
            </tbody>
            <tfoot>
              <tr>
                <td style="border:none; text-align: right" colspan="5"><b>SUB TOTAL</b></td>
                <td><b>{{ calcDebitCredit() }} {{ invoice.currency }}</b></td>
              </tr>
            </tfoot>
          </table>
        </template>
        <h2 style="margin-top: 0px; text-align: right;"><b>Total</b> {{ invoice.value }} {{ invoice.currency }}</h2>
        <table class="table is-bordered" style="width: 400px; text-align: right;" v-show="parseInt(invoice.payment) == 1">
          <tbody>
            <tr>
              <td colspan="2" style="text-align: center;"><b>Payment Info</b></td>
            </tr>
            <tr>
              <td><b>Status</b></td>
              <td>{{ parseInt(invoice.payment) == 1 ? 'Payed': 'Unpaid'}}</td>
            </tr>
            <tr>
              <td><b>Deposit Date</b></td>
              <td>{{ invoice.deposit_date | moment('YYYY-MM-DD')}}</td>
            </tr>
            <tr>
              <td><b>Payment Method</b></td>
              <td>{{ parsePaymentMethod(invoice.payment_method) }}</td>
            </tr>
            <tr v-if="invoice.exchange">
              <td><b>Exchange</b></td>
              <td>{{ invoice.exchange }}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(false)">Cancel</a>
          </p>
          <p class="control">
            <template>
              <a class="button is-success" @click="pdf">Export PDF</a>
              <a class="button is-info" @click="csv">Export CSV</a>
              <a class="button is-warning" @click="xls">Export XLS</a>
            </template>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  import Tooltip from 'vue-bulma-tooltip'
  import Payment from '../finances/payment'
  export default {
    props: {
      context: {
        type: Object
      },
      invoice_id: {
        type: Number,
        required: true
      },
      edit: {
        type: Boolean,
        default: false
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        invoice: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      parsePaymentMethod (method) {
        if (method !== null) {
          let methodName = ''
          if (parseInt(method.method_type) === 1) {
            methodName = 'CARD - ' + method.card_number + ' - ' + method.card_flag
          } else {
            methodName = 'BANK - ' + method.bank
            if (method.account !== null) {
              methodName = methodName + ' - ' + method.account
            }
            if (method.agency !== null) {
              methodName = methodName + ' - ' + method.agency
            }
          }
          return methodName
        } else {
          return ''
        }
      },
      openPayment (id) {
        let propsData = {
          context: this.context,
          payment_id: id,
          edit: true,
          callback: ''
        }
        Payment.openPayment(propsData)
      },
      excludeAll () {
        if (window.confirm('You are sure exclude all services')) {
          for (var i = 0; i < this.invoice.invoice_services.length; i++) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/invoice/exclude_service', {invoice: this.invoice_id, service: this.invoice.invoice_services[i].service_id}).then((response) => {
              let propsData = {
                title: 'Success',
                message: 'The service was successfully removed',
                type: 'success',
                direction: 'down',
                duration: 4500,
                showCloseButton: true
              }
              message.openMessage(propsData)
              this.loadData()
            }, (response) => {
              this.message('danger', 'Error', response.body)
            })
          }
        }
      },
      url (service) {
        window.open('#/services/service/' + service)
      },
      showExclude () {
        return (parseInt(this.invoice.payment) !== 1) && parseInt(this.context.$store.state.config.user.level) < 99 && (parseInt(this.invoice.protected) === 0)
      },
      calcServices () {
        let total = 0
        for (var i = 0; i < this.invoice.invoice_services.length; i++) {
          if ((this.invoice.invoice_services[i].service.status === 'Confirmed') || (this.invoice.invoice_services[i].service.status === 'PendingCancellation') || ((this.invoice.invoice_services[i].service.status === 'Cancelled') && ((new Date(this.invoice.invoice_services[i].service.service_date)).getTime() <= (new Date(this.invoice.invoice_services[i].service.cancellation_date)).getTime())) || parseInt(this.invoice.invoice_services[i].service.dispute) === 1 || parseInt(this.invoice.invoice_services[i].protected) === 1) {
            if ((this.invoice.base !== null) && (parseInt(this.invoice.base.is_markup) === 1)) {
              total = total + parseFloat((this.invoice.invoice_services[i].service.room.provider_price) / ((100 - this.invoice.base.markup) / 100) + parseFloat(this.invoice.base.bf))
            } else {
              total = total + parseFloat(this.invoice.invoice_services[i].service.price)
            }
          }
        }
        return total.toFixed(2)
      },
      calcDebitCredit () {
        let total = 0
        for (var i = 0; i < this.invoice.invoice_financials.length; i++) {
          if (parseInt(this.invoice.invoice_financials[i].financial.type) === 2) {
            total = total + parseFloat(this.invoice.invoice_financials[i].financial.gross_price)
          } else {
            total = total - parseFloat(this.invoice.invoice_financials[i].financial.gross_price)
          }
        }
        return total.toFixed(2)
      },
      showDebitCredit () {
        for (var i = 0; i < this.invoice.invoice_financials.length; i++) {
          return true
        }
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/invoice/' + this.invoice_id).then((response) => {
          this.invoice = response.body
          if (response.body === '') {
            this.close(false)
          } else {
            document.body.appendChild(this.$el)
          }
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      close (closeOnly, result) {
        if ((!closeOnly) && (typeof this.context[this.callback] === 'function')) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      pdf () {
        window.location.href = this.context.$store.state.config.apiURL + '/invoice/pdf/' + this.invoice_id
      },
      xls () {
        window.location.href = this.context.$store.state.config.apiURL + '/invoice/xls/' + this.invoice_id
      },
      csv () {
        window.location.href = this.context.$store.state.config.apiURL + '/invoice/csv/' + this.invoice_id
      },
      getName () {
        if (this.invoice.base !== null) {
          return this.invoice.base.name
        } else {
          return this.invoice.agency.name
        }
      },
      parseDate (content) {
        return this.$moment(content).format('YYYY-MM-DD')
      },
      exclude (id, service) {
        if (window.confirm('You are sure exclude service #' + service)) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/invoice/exclude_service', {invoice: this.invoice_id, service: id}).then((response) => {
            let propsData = {
              title: 'Success',
              message: 'The service was successfully removed',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            message.openMessage(propsData)
            this.loadData()
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      },
      excludeFinancial (id) {
        if (window.confirm('You are sure exclude financial #' + id)) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/invoice/exclude_financial', {invoice: this.invoice_id, financial: id}).then((response) => {
            let propsData = {
              title: 'Success',
              message: 'The financial was successfully removed',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            message.openMessage(propsData)
            this.loadData()
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      Tooltip
    }
  }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Invoice.vue?7055d695